module.exports = __webpack_public_path__ + "static/img/bg-tr.f73d849b.webp";